export const selectFile = async (accept: string = "audio/*") => {
  return new Promise<File>((resolve, reject) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = accept;

    input.onchange = (e) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];
      if (file) {
        // Verify it's an audio file
        if (!file.type.startsWith("audio/")) {
          reject(new Error("Please select an audio file"));
          return;
        }
        resolve(file);
      } else {
        reject(new Error("No file selected"));
      }
    };

    input.click();
  });
};

// Utility: Zip a set of files (filename -> {content}) into a Blob
export async function zipFiles(files: { [filename: string]: { content: string } }): Promise<Blob> {
  const JSZip = (await import("jszip")).default;
  const zip = new JSZip();
  for (const [filename, fileData] of Object.entries(files)) {
    zip.file(filename, fileData.content);
  }
  return zip.generateAsync({ type: "blob" });
}

// Utility: Unzip a base64-encoded zip string into { filename: content }
export async function unzipCode(base64: string): Promise<{ [filename: string]: string }> {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  const JSZip = (await import("jszip")).default;
  const zip = new JSZip();
  const zipContent = await zip.loadAsync(bytes);
  const extractedFiles: { [filename: string]: string } = {};
  for (const [filename, file] of Object.entries(zipContent.files)) {
    const zipFile = file as any;
    if (!zipFile.dir) {
      extractedFiles[filename] = await zipFile.async("string");
    }
  }
  return extractedFiles;
}
